$(document).ready(function() {
  $('.announcement-text').slick({
    dots: false,
    autoplay:true,
    autoplaySpeed:3000,
  });

 var saleEndTime = new Date("2025-12-02T23:59:59").getTime();
  function updateTimer() {
    var now = new Date().getTime();
    var timeLeft = saleEndTime - now;

    if (timeLeft > 0) {
      var days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
      var seconds = Math.floor((timeLeft / 1000) % 60);

      $("#days").text(days.toString().padStart(2, "0"));
      $("#hours").text(hours.toString().padStart(2, "0"));
      $("#minutes").text(minutes.toString().padStart(2, "0"));
      $("#seconds").text(seconds.toString().padStart(2, "0"));
    } else {
      clearInterval(timerInterval);
      $("#saleTimer").html("<span class='expired'>Sale Ended!</span>");
    }
  }

  // Update every second
  var timerInterval = setInterval(updateTimer, 1000);
  updateTimer(); // Run once immediately   
    
 });